import React from "react";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { fetchAvailableQuestions, formatReportDate } from "../../../portal";
const PENDING_AVAILABLE_INITIAL_STATE = {
  loading: false,
  history: [],
  filtered: [],
  hasError: false
};
const AVAILABLE_FILTERS_INITIAL_STATE = {
  selectedGroups: [],
  responded: false,
  forwarded: false,
  reviewed: false,
  incentive: false
};
const UPDATE_AVAILABLE_QUESTIONS = "update-available-questions";
const RESET_AVAILABLE_QUESTIONS = "reset-available-questions";
const SET_LOAD_AVAILABLE_QUESTIONS = "load-available-questions";
const availableQuestionsReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_AVAILABLE_QUESTIONS:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case SET_LOAD_AVAILABLE_QUESTIONS:
      return {
        ...state,
        loading: true
      };
    case RESET_AVAILABLE_QUESTIONS:
      return PENDING_AVAILABLE_INITIAL_STATE;
    default:
      throw new Error(`Unsupported available questions action type ${action.tyoe}`);
  }
};
const UPDATE_AVAILABLE_FILTERS = "update-available-filters";
const RESET_AVAILABLE_FILTERS = "reset-available-filters";
const availableQuestionsFilterReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_AVAILABLE_FILTERS:
      return {
        ...state,
        ...action.payload
      };
    case RESET_AVAILABLE_FILTERS:
      return AVAILABLE_FILTERS_INITIAL_STATE;
    default:
      throw new Error(`Unsupported available questions action type ${action.tyoe}`);
  }
};
export const useExpertAvailableQuestions = () => {
  const [availableQuestions, dispatchQuestions] = React.useReducer(availableQuestionsReducer, PENDING_AVAILABLE_INITIAL_STATE);
  const [availableFilters, dispatchFilters] = React.useReducer(availableQuestionsFilterReducer, AVAILABLE_FILTERS_INITIAL_STATE);
  const [availableRewardGroups, setAvailableRewardGroups] = React.useState([]);
  const {
    addFailureNotification
  } = useNotificationContext();
  const availableFilterExists = availableFilters.selectedGroups.length > 0 || availableFilters.responded || availableFilters.forwarded || availableFilters.reviewed || availableFilters.incentive;
  React.useEffect(() => {
    applyFilters();
  }, [availableFilters]);
  React.useEffect(() => {
    if (availableQuestions.history.length > 0 && availableRewardGroups.length === 0) {
      const groupNames = [];
      const groups = availableQuestions.history.map(item => {
        if (!groupNames.includes(item.groupName)) {
          groupNames.push(item.groupName);
          return {
            label: item.groupName,
            value: item.groupName
          };
        }
        return null;
      });
      setAvailableRewardGroups(groups.filter(i => i));
    }
  }, [availableQuestions]);
  const updateAvailableFilters = values => {
    dispatchFilters({
      type: UPDATE_AVAILABLE_FILTERS,
      payload: {
        ...availableFilters,
        ...values
      }
    });
  };
  const clearAvailableFilters = () => {
    dispatchFilters({
      type: RESET_AVAILABLE_FILTERS
    });
    dispatchQuestions({
      type: RESET_AVAILABLE_QUESTIONS
    });
    loadExpertAvailableRewards();
  };
  const applyFilters = () => {
    dispatchQuestions({
      type: UPDATE_AVAILABLE_QUESTIONS,
      payload: {
        loading: true
      }
    });
    const filteredHistory = availableQuestions.history.filter(item => {
      const groupHasSelection = availableFilters.selectedGroups.length !== 0;
      const isGroupSelected = groupHasSelection && availableFilters.selectedGroups.map(i => i.value).includes(item.groupName);
      const rewardTypeHasSelection = availableFilters.responded === true || availableFilters.forwarded === true || availableFilters.reviewed === true || availableFilters.adjustment === true || availableFilters.incentive === true;
      const isRewardTypeSelected = availableFilters.responded === true && item.type === "Responded" || availableFilters.forwarded === true && item.type === "Escalated" || availableFilters.reviewed === true && item.type === "Reviewed" || availableFilters.adjustment === true && item.type === "Adjustment" || availableFilters.incentive === true && item.type === "Incentive";
      let returnItem = true;
      if (groupHasSelection && !isGroupSelected) {
        returnItem = false;
      }
      if (rewardTypeHasSelection && !isRewardTypeSelected) {
        returnItem = false;
      }
      return returnItem;
    });
    dispatchQuestions({
      type: UPDATE_AVAILABLE_QUESTIONS,
      payload: {
        ...availableQuestions,
        filtered: filteredHistory,
        loading: false
      }
    });
  };
  const loadExpertAvailableRewards = () => {
    dispatchQuestions({
      type: SET_LOAD_AVAILABLE_QUESTIONS,
      payload: {
        ...availableQuestions
      }
    });
    fetchAvailableQuestions(response => {
      if (!response.hasError) {
        const filteredAvailableQuestions = response.map(prop => {
          prop.formatReportDate = formatReportDate(prop.created, {
            showDateOnly: true
          }) || "-";
          prop.formattedProportion = `${prop.proportion * 100}%`;
          delete prop.country;
          delete prop.currency;
          return prop;
        });
        dispatchQuestions({
          type: UPDATE_AVAILABLE_QUESTIONS,
          payload: {
            ...availableQuestions,
            history: filteredAvailableQuestions,
            filtered: filteredAvailableQuestions,
            hasError: false,
            loading: false
          }
        });
      } else {
        addFailureNotification("Failed to find available fee allocation tasks");
        dispatchQuestions({
          type: UPDATE_AVAILABLE_QUESTIONS,
          payload: {
            ...availableQuestions,
            history: [],
            hasError: true,
            loading: false
          }
        });
      }
    });
  };
  return {
    loadExpertAvailableRewards,
    availableQuestions,
    availableFilterExists,
    availableRewardGroups,
    availableFilters,
    updateAvailableFilters,
    clearAvailableFilters
  };
};